import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalContext from '../utils/GlobalContext';
import Modal from './Modal';
import Button from './Button';

export default function ConfirmationModalBase({
  confirmText,
  cancelText,
  header = false,
}) {
  const dispatch = useDispatch();
  const { locales } = useContext(GlobalContext);
  const {
    confirmationModal: { show, body, handleCancel, handleConfirm },
  } = useSelector((state) => state.common);

  const confirmLabel = confirmText || locales.common.confirm;
  const cancelLabel = cancelText || locales.common.cancel;

  if (show) {
    return (
      <Modal
        className="confirmation-modal sm"
        header={header}
        isOpen={show}
        onClose={() => {
          dispatch.common.closeModal();
        }}
      >
        <p className="confirmation-modal__body-title">{body}</p>
        <div className="flex flex-1 flex-row gap-2 mt-8 justify-end">
          <Button variant="outline" onClick={handleCancel}>
            {cancelLabel}
          </Button>
          <Button variant="destructiveOutline" onClick={handleConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </Modal>
    );
  }

  return null;
}
